<template>
    <a :href="typeof(href)=='undefined'?'javascript:;':href">
        <btn :type="type||'primary'" :operation="operation" :disabled="disabled" size="small" @click="clickEventProxy" :loading="loading">
            <slot></slot>
        </btn>
    </a>
</template>
<script>
export default {
    props: ['disabled', 'operation', 'type','href', 'op', 'loading'],
    methods: {
        clickEventProxy(event) {
            this.$emit('click', event);
        }
    }
}
</script>